





















































// Libraries
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

import VueClipboard from 'vue-clipboard2'

// Mixins
import MatchMixin from '@/mixins/match'

// Sub views
import MatchForm from '@/components/Forms/MatchForm.vue'

// VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

@Component({
  components: {
    MatchForm,
  },

  computed: {
    ...mapState('match', ['match']),
  },
})
export default class ApiLinkDialog extends MatchMixin {
  @Prop() readonly dialog!: { open: boolean }

  /**
   * Copy API-link to clipboard
   */
  copyToClipboard(): void {
    if (!this.match) {
      return
    }
    const apiLink = this.apiLink

    if (!apiLink) {
      window.flash('Unable to copy API-link.', 'error')
      return
    }

    // Ref to 'container' (button) to ensure recognisition of button-element that has been touched
    // https://github.com/Inndy/vue-clipboard2/issues/59#issuecomment-525675314
    const ref = this.$refs.apiLinkCopyButton as Vue

    if (!ref) {
      window.flash('Unable to copy API-link.', 'error')
      return
    }

    // console.log(apiLink)

    this.$copyText(apiLink, ref.$el).then(() => {
      // console.log(x)
      window.flash(`Copied API-link for the match!`)
    })
  }
}
